/**
 * @generated SignedSource<<4aa56db7200cfb35652237e4ce800232>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type Currency = "CAD" | "EUR" | "GBP" | "USD";
import { FragmentRefs } from "relay-runtime";
export type ClubCurrencyContextUnauthenticatedFragment$data = {
  readonly currency: Currency;
  readonly " $fragmentType": "ClubCurrencyContextUnauthenticatedFragment";
};
export type ClubCurrencyContextUnauthenticatedFragment$key = {
  readonly " $data"?: ClubCurrencyContextUnauthenticatedFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ClubCurrencyContextUnauthenticatedFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ClubCurrencyContextUnauthenticatedFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currency",
      "storageKey": null
    }
  ],
  "type": "UnauthenticatedClub",
  "abstractKey": null
};

(node as any).hash = "90ac42ea9fc05b9894ea702bc5a008c6";

export default node;
